import { TransactionHistoryRequestModel } from "app/based/baseApiModel/baseTransactionHistory/TransactionHistoryRequestModel";

export class AirTimeRegistrationRequestModel extends TransactionHistoryRequestModel {
  carrier?: Array<string>;
  code?: string;
  created?: Record<string, unknown>[];
  fromDate?: string;
  limit?: number;
  page?: number;
  pagination?: boolean;
  phoneNumber?: string;
  status?: number;
  toDate?: string;
  userRef?: Array<string>;
  partnerCodes?: Array<string>;
  isOnlyStore?: string;
  order?: string;
  serviceCode?: string;
  storeCodes?: Array<string>;
  providerCode?: string;
  carrierCodes?: Array<string>;
  codeAirTime?: string;
  transRef?: string;
  supplierRefCode?: string;

  constructor(data?: Partial<AirTimeRegistrationRequestModel>) {
    super();
    this.carrier = data?.carrier;
    this.code = data?.code;
    this.created = data?.created;
    this.fromDate = data?.fromDate;
    this.limit = data?.limit;
    this.page = data?.page;
    this.pagination = data?.pagination;
    this.phoneNumber = data?.phoneNumber;
    this.status = data?.status;
    this.toDate = data?.toDate;
    this.storeCodes = data?.storeCodes;
    this.userRef = data?.userRef;
    this.partnerCodes = data?.partnerCodes;
    this.order = data?.order;
    this.isOnlyStore = data?.isOnlyStore;
    this.serviceCode = data?.serviceCode;
    this.providerCode = data?.providerCode;
    this.carrierCodes = data?.carrierCodes;
    this.codeAirTime = data?.codeAirTime;
    this.transRef = data?.transRef;
    this.supplierRefCode = data?.supplierRefCode;
  }
}
